import React, { Component } from "react";
import { array } from "prop-types";
import BloxButton from "sub_components/Common/BloxButton";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const NetworkDefault = `${CDN_URL}support/ticketing/icon-network-default-lg.svg`;
const NetworkSelected = `${CDN_URL}support/ticketing/icon-network-selected-lg.svg`;
const ColoDefault = `${CDN_URL}support/ticketing/icon-colo-default-lg.svg`;
const ColoSelected = `${CDN_URL}support/ticketing/icon-colo-selected-lg.svg`;
const StorageDefault = `${CDN_URL}support/ticketing/icon-storage-default-lg.svg`;
const StorageSelected = `${CDN_URL}support/ticketing/icon-storage-selected-lg.svg`;
const PortalDefault = `${CDN_URL}support/ticketing/icon-portal-default-lg.svg`;
const PortalSelected = `${CDN_URL}support/ticketing/icon-portal-selected-lg.svg`;

class ProductSelection extends Component {
  onMouseEnter = (id) => {
    const icon = document.getElementById(id);

    if (id === "co-lo") {
      icon.src = ColoSelected;
    } else if (id === "Storage") {
      icon.src = StorageSelected;
    } else if (id === "portal") {
      icon.src = PortalSelected;
    } else {
      icon.src = NetworkSelected;
    }
  };
  onMouseLeave = (id, typeIcon) => {
    const icon = document.getElementById(id);

    icon.src = typeIcon;
  };

  hasService = (service) => {
    const { services } = this.props;
    let filteredCompanyServices = [];

    if (services) {
      filteredCompanyServices =
        services &&
        services.length !== 0 &&
        services.filter(
          (coService) => coService.name === service && coService.active === true
        );
    }

    if (
      filteredCompanyServices.length === 0 &&
      services !== null &&
      services.length !== 0
    ) {
      return false;
    } else {
      return true;
    }
  };
  updateEditParams = (product) => {
    const { updateData, closeEditModal } = this.props;
    updateData("product", null, product);

    closeEditModal();
  };

  render() {
    const { data, onSelect, closeModal, phase } = this.props;
    const selected = data.product;
    const { type } = data;
    const networkIcon =
      selected === "Network Services" ? NetworkSelected : NetworkDefault;
    const coloIcon = selected === "Colocation" ? ColoSelected : ColoDefault;
    const storageIcon =
      selected === "Storage" ? StorageSelected : StorageDefault;
    const portalIcon = selected === "portal" ? PortalSelected : PortalDefault;

    return (
      <div className="product-selection-stage">
        <div
          className={
            type === "support" &&
            this.hasService("colo") &&
            this.hasService("storage") &&
            this.hasService("network")
              ? "product-selection-wrapper wrap"
              : "product-selection-wrapper"
          }
        >
          {this.hasService("colo") && (
            <div
              className="product-selection"
              onClick={
                phase !== "edit"
                  ? () => onSelect("product", { data: "Colocation" }, true)
                  : () => this.updateEditParams("Colocation")
              }
              onMouseEnter={() => this.onMouseEnter("co-lo", coloIcon)}
              onMouseLeave={() => this.onMouseLeave("co-lo", coloIcon)}
              data-cy="colo"
            >
              <img src={coloIcon} id="co-lo" />
              <div className="title heading76">Co-Lo</div>
            </div>
          )}

          {this.hasService("storage") && (
            <div
              className={`product-selection `}
              onClick={
                phase !== "edit"
                  ? () => onSelect("product", { data: "Storage" }, true)
                  : () => this.updateEditParams("Storage")
              }
              onMouseEnter={() => this.onMouseEnter("Storage", storageIcon)}
              onMouseLeave={() => this.onMouseLeave("Storage", storageIcon)}
              data-cy="storage"
            >
              <img src={storageIcon} id="Storage" />
              <div className="title heading76">Storage</div>
            </div>
          )}
          {this.hasService("network") && (
            <div
              className={`product-selection  `}
              onClick={
                phase !== "edit"
                  ? () =>
                      onSelect("product", { data: "Network Services" }, true)
                  : () => this.updateEditParams("Network Services")
              }
              onMouseEnter={() => this.onMouseEnter("Network", networkIcon)}
              onMouseLeave={() => this.onMouseLeave("Network", networkIcon)}
              data-cy="network-services"
            >
              <img src={networkIcon} id="Network" />
              <div className="title heading76">Network</div>
            </div>
          )}
          {type === "support" && (
            <div
              className={`product-selection  `}
              onClick={
                phase !== "edit"
                  ? () => onSelect("product", { data: "Portal" }, true)
                  : () => this.updateEditParams("Portal")
              }
              onMouseEnter={() => this.onMouseEnter("portal", portalIcon)}
              onMouseLeave={() => this.onMouseLeave("portal", portalIcon)}
              data-cy="portal"
            >
              <img src={portalIcon} id="portal" />
              <div className="title heading76">Portal</div>
            </div>
          )}
        </div>

        {phase !== "edit" && (
          <div className="cancel-button">
            <BloxButton
              title="CANCEL"
              enabled={true}
              customClass="blox-button-swipe"
              onClick={closeModal}
              id="cancel-button-swipe"
            />
          </div>
        )}
      </div>
    );
  }
}

ProductSelection.propTypes = {
  services: array,
};

ProductSelection.defaultProps = {
  services: [],
};

export default ProductSelection;
